import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-vignette",
  "use": "icon-th-vignette-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-vignette\">\n<path d=\"M27 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V25C3 25.5304 3.21071 26.0391 3.58579 26.4142C3.96086 26.7893 4.46957 27 5 27H27C27.5304 27 28.0391 26.7893 28.4142 26.4142C28.7893 26.0391 29 25.5304 29 25V7C29 6.46957 28.7893 5.96086 28.4142 5.58579C28.0391 5.21071 27.5304 5 27 5ZM27 25H5V7H27V25ZM22.2563 10.9575C20.5737 9.695 18.3512 9 16 9C13.6488 9 11.4263 9.695 9.75 10.9575C7.97375 12.2838 7 14.075 7 16C7 17.925 7.97375 19.7162 9.75 21.0425C11.4263 22.305 13.6488 23 16 23C18.3512 23 20.5737 22.305 22.2563 21.0425C24.0263 19.7162 25 17.925 25 16C25 14.075 24.0263 12.2838 22.2563 10.9575ZM16 21C12.14 21 9 18.7575 9 16C9 13.2425 12.14 11 16 11C19.86 11 23 13.2425 23 16C23 18.7575 19.86 21 16 21Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-vignette.svg
// module id = gNZd
// module chunks = 84